import { Generic } from './Quote';
export function isQuote(node) {
    return node !== null && typeof node === 'object' && node instanceof Generic;
}
export default isQuote;    //# sourceMappingURL=isQuote.js.map
